// extracted by mini-css-extract-plugin
export default {"bannerTitle":"abRw71"};